import { Field } from 'module/api/field/types';
import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import { Tag } from 'module/ui/components/atoms/tag';
import { AccountPeopleProfile } from 'api/account-people/profile-type';
import { useGetExternalTeamMembersFieldsQuery } from 'queries/fields';
import { useMemo } from 'react';

const influenceFieldName = 'influence';
const sentimentFieldName = 'sentiment';
const useGetInfluenceField = () => {
  const { data: peopleFields } = useGetExternalTeamMembersFieldsQuery();

  return useMemo(
    () => peopleFields?.find((x) => x.fieldName === influenceFieldName),
    [peopleFields],
  );
};
const useGetSentimentField = () => {
  const { data: peopleFields } = useGetExternalTeamMembersFieldsQuery();

  return useMemo(
    () => peopleFields?.find((x) => x.fieldName === sentimentFieldName),
    [peopleFields],
  );
};
const getFieldValue = (field: Field, user: AccountPeopleProfile['user']) => {
  const fieldValue = user.fields?.find((x) => x.fieldId === field.fieldId);
  const selectOption = field.metaData?.options?.find(
    (x) => x.value === fieldValue?.fieldValue,
  );

  return selectOption;
};

interface PriorityFieldsProps {
  userProfile: AccountPeopleProfile;
}

export const PriorityFields = ({ userProfile }: PriorityFieldsProps) => {
  const influenceField = useGetInfluenceField();
  const sentimentField = useGetSentimentField();
  const influenceFieldValue = useMemo(
    () => influenceField && getFieldValue(influenceField, userProfile.user),
    [influenceField, userProfile.user],
  );
  const sentimentFieldValue = useMemo(
    () => sentimentField && getFieldValue(sentimentField, userProfile.user),
    [sentimentField, userProfile.user],
  );

  if (
    (influenceField == null && sentimentField == null) ||
    (influenceFieldValue == null && sentimentFieldValue == null)
  ) {
    return <></>;
  }

  return (
    <CenterAlignedBox>
      {influenceFieldValue != null && (
        <Tag color={influenceFieldValue.color}>{influenceFieldValue.label}</Tag>
      )}
      {sentimentFieldValue != null && (
        <Tag color={sentimentFieldValue.color}>{sentimentFieldValue.label}</Tag>
      )}
    </CenterAlignedBox>
  );
};
